import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to #hash targets on route change (waits for content to mount),
// otherwise scrolls to top on plain navigations.
export default function ScrollToHash() {
  const { pathname, hash, key } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace("#", "");
      let tries = 0;
      const t = setInterval(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          clearInterval(t);
        }
        if (++tries > 25) clearInterval(t);
      }, 90);
      return () => clearInterval(t);
    }
    window.scrollTo(0, 0);
  }, [pathname, hash, key]);
  return null;
}
